import { capitalizeInitialLetter } from "@/lib/string-util";
import type { ProviderCost } from "@/model/provider-cost";
import React from "react";

type ProviderInfoProps = {
  providerCost: ProviderCost;
};

const CostEstimatorProviderInfo: React.FC<ProviderInfoProps> = ({
  providerCost,
}) => {
  // console.log("## providerCost = ", providerCost.provider?.fullName);
  return (
    <div className="overflow-y-auto p-4">
      <div className="mb-4 space-y-2">
        <div>
          <span className="text-sm font-semibold text-gray-800">
            Provider Name:
          </span>{" "}
          <span className="text-sm text-gray-700">
            {providerCost.provider?.fullName ?? ""}
          </span>
        </div>

        <div>
          <span className="text-sm font-semibold text-gray-800">
            Provider Group ID:
          </span>{" "}
          <span className="text-sm text-gray-700">
            {providerCost.provider?.providerGroupId ?? ""}
          </span>
        </div>

        <div>
          <span className="text-sm font-semibold text-gray-800">
            Provider EIN:
          </span>{" "}
          <span className="text-sm text-gray-700">
            {providerCost.einDetail?.id ?? ""}
          </span>
        </div>

        <div>
          <span className="text-sm font-semibold text-gray-800">
            Specialty:
          </span>{" "}
          <span className="text-sm text-gray-700">
            {providerCost.provider?.specialityDetails
              .map((item) => item.description)
              .join(", ")}
          </span>
        </div>
        {providerCost?.einDetail?.name !== null ? (
          <div>
            <span className="text-sm font-semibold text-gray-800">
              Facility Name:
            </span>{" "}
            <span className="text-sm text-gray-700">
              {capitalizeInitialLetter(providerCost?.einDetail?.name ?? "")}
            </span>
          </div>
        ) : null}
      </div>

      <div>
        <h3 className="mb-4 text-sm font-bold text-gray-800">
          Taxonomy Code / Description:
        </h3>
        <div className="rounded-lg border border-gray-300">
          <div className="grid grid-cols-2 bg-gray-200">
            <div className="px-4 py-3 text-center font-semibold text-gray-800">
              <span className="text-sm">Code</span>
            </div>
            <div className="px-4 py-3 text-center font-semibold text-gray-800">
              <span className="text-sm">Description</span>
            </div>
          </div>

          {providerCost?.provider?.specialityDetails.map((item, index) => (
            <div
              key={index}
              className="grid grid-cols-2 border-t border-gray-300"
            >
              <div className="p-4 text-center">
                <span className="text-sm">{item.code}</span>
              </div>
              <div className="p-4 text-center">
                <span className="text-sm">{item.description}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CostEstimatorProviderInfo;
